import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { fetchP24TransactionRefunds } from "../../actions/p24TransactionActions";

import { formatDateTime, formatMoneyDiv100 } from "../../helpers/utils";

import { getP24RefundStatusById } from "../../constants/P24RefundStatus"

const RefundItem = ({ item }) => {
    return (
        <div>
            <div className={item.p24Status ? "w3-container w3-green" : "w3-container w3-pink"}>
                <h5 className="w3-center">{item.description} - {formatDateTime(item.creationDate)}</h5>
            </div>

            <div className={item.p24Status ? "w3-container w3-pale-green" : "w3-container w3-pale-red"}>
                <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.id}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.id"
                                defaultMessage="id"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {item.p24OrderId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.p24OrderId"
                                defaultMessage="p24OrderId"
                            />
                        </label>
                    </div>

                    <div className="w3-col s8">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {item.sessionId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.sessionId"
                                defaultMessage="sessionId"
                            />
                        </label>
                    </div>


                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {formatMoneyDiv100(item.amount)}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.amount"
                                defaultMessage="amount"
                            />
                        </label>
                    </div>

                    <div className="w3-col s10">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {item.p24Message}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.p24Message"
                                defaultMessage="p24Message"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s12">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {item.requestId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.requestId"
                                defaultMessage="requestId"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s12">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {item.urlStatus}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.urlStatus"
                                defaultMessage="urlStatus"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {formatDateTime(item.registrationDate)}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.registrationDate"
                                defaultMessage="registrationDate"
                            />
                        </label>
                    </div>

                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {formatDateTime(item.notificationDate)}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.notificationDate"
                                defaultMessage="notificationDate"
                            />
                        </label>
                    </div>

                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {getP24RefundStatusById(item.p24RefundStatus).displayText}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Refund.p24RefundStatus"
                                defaultMessage="p24RefundStatus"
                            />
                        </label>
                    </div>

                </div>

            </div>
        </div>
    )
}

const RefundItemList = ({ items }) => {

    //sprawdzamy czy sa jakies elementy, aby dodac scrolla, a innym wypadku nie chcemy takeigo duzego modala
    if (items.length > 0) {
        return (
            <div style={{ overflowY: 'auto', maxHeight: '700px' }}>
                {items.map(item => <RefundItem item={item} />)}
            </div>
        )
    }

    return (
        <div className="w3-center">
            &lt;Brak&gt;
        </div>
    )
}

class P24TransactionRefunds extends React.Component {

    componentDidMount() {

        console.log('transaction id', this.props.transaction.id)

        this.props.fetchP24TransactionRefunds(this.props.transaction.id);
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };


    render() {

        console.log(this.props.transaction)
        console.log(this.props.p24TransactionRefunds)

        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">Dane zwrotów w systemie Flow24</h2>
                </div>



                <RefundItemList items={this.props.p24TransactionRefunds} />


                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            Zamknij
                        </button>
                    </div>
                </form>
            </div >
        )
    }

}

P24TransactionRefunds.propTypes = {
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    p24TransactionRefunds: state.p24TransactionReducer.p24TransactionRefunds
});

const mapDispatchToProps = ({
    fetchP24TransactionRefunds: fetchP24TransactionRefunds
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24TransactionRefunds);